import type { SxProps } from '@mui/material';
import { mergeSx } from 'design-system';
import type { BaseTheme } from 'design-system';

export function getFieldControlSx(hasWhiteFields: boolean, baseSx?: SxProps<BaseTheme>): SxProps<BaseTheme> {
  return mergeSx(baseSx ?? {}, (theme) => ({
    background: hasWhiteFields ? theme.palette.background.paper : 'initial',
    borderRadius: theme.spacing(1),
  }));
}
